import * as signalR from "@microsoft/signalr";

const URL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'http://localhost:5037/api/userpanelhub' : '/api/userpanelhub';

export interface IUserPanelHubDto {
    MessageGuid?: any;
    Data: {
        [key: string]: { Message: string; Id: number; RowGuid: any; Path: string; }[]
    };
}

export class UserPanelHubConnector {
    private connection: signalR.HubConnection;
    public subscribeEvents: (onMessageReceived: (data: IUserPanelHubDto) => void) => void;
    public unsubscribeEvents: () => void;
    static instance?: UserPanelHubConnector;
    constructor() {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(URL, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets
            })
            .withAutomaticReconnect()
            .build();
        this.connection.start().catch(err => console.error(err));
        this.subscribeEvents = onMessageReceived => {
            this.connection.on("messageReceived", data => {
                onMessageReceived(JSON.parse(data));
            });
        };
        this.unsubscribeEvents = () => {
            this.connection.off("messageReceived");
            this.connection.stop();
        };
    }
}
